// Steam Barons — character lore (server-safe). Generated by create-mod.
import data from './steam-barons.data.json';

export const CHARACTER_LORE = data.lore;

export function getLoreById(id) {
  return CHARACTER_LORE[id] || null;
}
